import { EnginePositionModel } from '../models/engine-position.model';
import { BdGraph } from '../../../lib/graph/graph.model';
import { ViewTreeNode } from '../models/view.tree-node';
import { ChapterInitModel } from '../models/engine-chapter-init-model';
import { ToolEnum } from '../models/tool.enum';
import { ScrollModeEnum } from '../models/scroll-mode.enum';
import { HitModel } from '../models/hit.model';

export class EngineStateModel {
  loading: boolean;
  engine: string;
  ready: boolean;

  viewGraph: BdGraph<ViewTreeNode>;
  hoveredNode: ViewTreeNode;
  labelEditNode: ViewTreeNode;
  contextmenu: {
    node: ViewTreeNode;
    hit: HitModel;
  };

  // query anatomy node info
  queryingAnatomy: boolean;

  chapter: string;
  chapterInit: ChapterInitModel;

  enginePosition?: EnginePositionModel;

  showCameraBar: boolean;
  showProgressBar: boolean;
  showLabels: boolean;

  activeTool: ToolEnum;
  display: boolean;
  visible: boolean;
  animationPlaying: boolean;
  autoplay: boolean;
  playAudio: boolean;
  scrollMode: ScrollModeEnum;
  playbackSpeed: number;

  // xray mode support
  xrayModeEnabled: boolean;
}
